/**
 * Tiny pub/sub used to trigger the post-wizard "completing setup"
 * transition for the VENUE persona — fired from
 * SetupVenueWizardCourts' Continue handler and consumed by
 * SetupVenueCompletingTransitionMount (rendered at App root, sibling
 * to <Routes>).
 *
 * Why a separate controller from the community
 * (setupCompletingTransitionController)? Two reasons:
 *
 *   1. The two loaders have different content (community surfaces
 *      venue thumbnails, venue surfaces court chips) and different
 *      navigation timing — the community loader navigates BEFORE
 *      mount because /community/welcome lives inside
 *      BoundaryAnimatedShell, while the venue loader navigates at
 *      mid-timeline (t=1500ms) because /venue-owner/welcome is a
 *      standalone route. Sharing a mount would tangle these two
 *      lifecycles.
 *   2. Triggering and subscribing per-persona keeps the dispatch
 *      narrow — App.jsx mounts both controllers as parallel
 *      siblings; only the matching one ever fires.
 *
 * Same pub/sub shape as the community controller so both loaders
 * follow the same wiring contract.
 */

let listeners = []

export function triggerSetupVenueCompletingTransition() {
  listeners.forEach((fn) => {
    try { fn() } catch { /* swallow — one bad listener mustn't break others */ }
  })
}

export function subscribeSetupVenueCompletingTransition(fn) {
  listeners.push(fn)
  return () => {
    listeners = listeners.filter((l) => l !== fn)
  }
}
